/**
 * Calculates the age based on a birthdate.
 * @param dateString Birthdate in string form.
 * @param currentDateOveride Optional. Defaults to current date.
 * @returns The current age.
 * @example
 * // returns 33
 * ageFromDob('1990-01-01');
 */
export function ageFromDob(
  /** Birthdate in string form. */
  dateString: string,
  /** Optional. Defaults to current date. */
  currentDateOveride?: string | undefined
) {
  const today = currentDateOveride ? new Date(currentDateOveride) : new Date();
  const birthDate = new Date(dateString);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}
